import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import Footer from "@/components/Footer";

export const PrivacyPage = () => {
  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white">
      <div className="max-w-4xl mx-auto px-6 py-24">
        <a href="/" data-testid="privacy-back-link" className="inline-flex items-center gap-2 text-[#FF6B00] mb-8 hover:underline">
          <ArrowLeft className="w-4 h-4" /> Terug naar home
        </a>
        <h1 className="text-4xl font-bold font-['Outfit'] mb-8">Privacybeleid</h1>
        <div className="prose prose-invert prose-orange max-w-none space-y-6 text-[#A1A1AA]">
          <p><strong className="text-white">Laatst bijgewerkt:</strong> {new Date().toLocaleDateString('nl-NL')}</p>
          
          <h2 className="text-2xl font-bold text-white mt-8">1. Wie zijn wij?</h2>
          <p>EG Bouw, gevestigd aan Torenallee 101, 5617BR Eindhoven, is verantwoordelijk voor de verwerking van persoonsgegevens zoals weergegeven in dit privacybeleid.</p>
          <p><strong className="text-white">Contactgegevens:</strong><br/>
          EG Bouw<br/>
          Torenallee 101, 5617BR Eindhoven<br/>
          Tel: 06 81 02 51 05<br/>
          Email: info@ella-gold.com<br/>
          KvK: 99681293</p>
          
          <h2 className="text-2xl font-bold text-white mt-8">2. Welke gegevens verzamelen wij?</h2>
          <p>Wij verzamelen de volgende persoonsgegevens wanneer u contact met ons opneemt of een offerte aanvraagt:</p>
          <ul className="list-disc pl-6">
            <li>Naam</li>
            <li>E-mailadres</li>
            <li>Telefoonnummer</li>
            <li>Beschrijving van uw project/vraag</li>
          </ul>
          
          <h2 className="text-2xl font-bold text-white mt-8">3. Waarom verzamelen wij deze gegevens?</h2>
          <p>Wij verwerken uw persoonsgegevens voor de volgende doeleinden:</p>
          <ul className="list-disc pl-6">
            <li>Om contact met u op te nemen over uw aanvraag</li>
            <li>Om een offerte op te stellen</li>
            <li>Om onze diensten aan u te kunnen leveren</li>
          </ul>
          
          <h2 className="text-2xl font-bold text-white mt-8">4. Bewaartermijn</h2>
          <p>Wij bewaren uw persoonsgegevens niet langer dan strikt noodzakelijk is. Offerteaanvragen worden maximaal 2 jaar bewaard.</p>
          
          <h2 className="text-2xl font-bold text-white mt-8">5. Delen met derden</h2>
          <p>Wij delen uw gegevens niet met derden, tenzij dit noodzakelijk is voor de uitvoering van onze overeenkomst of wettelijk verplicht is.</p>
          
          <h2 className="text-2xl font-bold text-white mt-8">6. Uw rechten</h2>
          <p>U heeft het recht om uw persoonsgegevens in te zien, te corrigeren of te verwijderen. Neem hiervoor contact met ons op via info@ella-gold.com.</p>
          
          <h2 className="text-2xl font-bold text-white mt-8">7. Cookies</h2>
          <p>Deze website gebruikt alleen functionele cookies om de website goed te laten functioneren. Wij gebruiken geen tracking cookies.</p>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export const TermsPage = () => {
  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white">
      <div className="max-w-4xl mx-auto px-6 py-24">
        <a href="/" data-testid="terms-back-link" className="inline-flex items-center gap-2 text-[#FF6B00] mb-8 hover:underline">
          <ArrowLeft className="w-4 h-4" /> Terug naar home
        </a>
        <h1 className="text-4xl font-bold font-['Outfit'] mb-8">Algemene Voorwaarden</h1>
        <div className="prose prose-invert prose-orange max-w-none space-y-6 text-[#A1A1AA]">
          <p><strong className="text-white">EG Bouw</strong> - Gevestigd te Eindhoven - KvK: 99681293</p>
          
          <h2 className="text-2xl font-bold text-white mt-8">Artikel 1 - Definities</h2>
          <p>In deze voorwaarden wordt verstaan onder:</p>
          <ul className="list-disc pl-6">
            <li><strong className="text-white">Opdrachtnemer:</strong> EG Bouw, gevestigd te Eindhoven</li>
            <li><strong className="text-white">Opdrachtgever:</strong> De natuurlijke of rechtspersoon die aan EG Bouw opdracht geeft tot het verrichten van werkzaamheden</li>
          </ul>
          
          <h2 className="text-2xl font-bold text-white mt-8">Artikel 2 - Toepasselijkheid</h2>
          <p>Deze voorwaarden zijn van toepassing op alle offertes, overeenkomsten en leveringen van EG Bouw, tenzij schriftelijk anders is overeengekomen.</p>
          
          <h2 className="text-2xl font-bold text-white mt-8">Artikel 3 - Offertes</h2>
          <p>Alle offertes zijn vrijblijvend en 30 dagen geldig, tenzij anders aangegeven. Prijzen zijn exclusief BTW, tenzij anders vermeld.</p>
          
          <h2 className="text-2xl font-bold text-white mt-8">Artikel 4 - Uitvoering</h2>
          <p>EG Bouw zal de werkzaamheden naar beste inzicht en vermogen uitvoeren. De uitvoeringstermijn is indicatief en geen fatale termijn.</p>
          
          <h2 className="text-2xl font-bold text-white mt-8">Artikel 5 - Betaling</h2>
          <p>Betaling dient te geschieden binnen 14 dagen na factuurdatum, tenzij anders overeengekomen. Bij grotere projecten kan een betalingsregeling worden afgesproken.</p>
          
          <h2 className="text-2xl font-bold text-white mt-8">Artikel 6 - Garantie</h2>
          <p>EG Bouw staat in voor de kwaliteit van het geleverde werk. Op het uitgevoerde werk geldt een garantietermijn van 1 jaar na oplevering.</p>
          
          <h2 className="text-2xl font-bold text-white mt-8">Artikel 7 - Aansprakelijkheid</h2>
          <p>EG Bouw is uitsluitend aansprakelijk voor directe schade die het gevolg is van opzet of grove nalatigheid. De aansprakelijkheid is beperkt tot het factuurbedrag.</p>
          
          <h2 className="text-2xl font-bold text-white mt-8">Artikel 8 - Geschillen</h2>
          <p>Op alle overeenkomsten is Nederlands recht van toepassing. Geschillen worden voorgelegd aan de bevoegde rechter te Eindhoven.</p>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export const DisclaimerPage = () => {
  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white">
      <div className="max-w-4xl mx-auto px-6 py-24">
        <a href="/" data-testid="disclaimer-back-link" className="inline-flex items-center gap-2 text-[#FF6B00] mb-8 hover:underline">
          <ArrowLeft className="w-4 h-4" /> Terug naar home
        </a>
        <h1 className="text-4xl font-bold font-['Outfit'] mb-8">Disclaimer</h1>
        <div className="prose prose-invert prose-orange max-w-none space-y-6 text-[#A1A1AA]">
          <h2 className="text-2xl font-bold text-white mt-8">Algemeen</h2>
          <p>De informatie op deze website is met zorg samengesteld. EG Bouw kan echter niet garanderen dat deze informatie altijd juist, volledig en actueel is.</p>
          
          <h2 className="text-2xl font-bold text-white mt-8">Aansprakelijkheid</h2>
          <p>EG Bouw aanvaardt geen enkele aansprakelijkheid voor schade, van welke aard dan ook, die voortvloeit uit of verband houdt met het gebruik van deze website of de onmogelijkheid deze te gebruiken.</p>
          
          <h2 className="text-2xl font-bold text-white mt-8">Afbeeldingen</h2>
          <p>De afbeeldingen op deze website zijn ter illustratie. Hieraan kunnen geen rechten worden ontleend. De getoonde projecten kunnen afwijken van de uiteindelijke uitvoering.</p>
          
          <h2 className="text-2xl font-bold text-white mt-8">Intellectueel eigendom</h2>
          <p>Alle teksten, afbeeldingen en andere materialen op deze website zijn eigendom van EG Bouw of worden gebruikt met toestemming van de rechthebbende. Niets van deze website mag worden gekopieerd zonder schriftelijke toestemming.</p>
          
          <h2 className="text-2xl font-bold text-white mt-8">Links naar derden</h2>
          <p>Deze website kan links bevatten naar websites van derden. EG Bouw is niet verantwoordelijk voor de inhoud van deze websites.</p>
          
          <h2 className="text-2xl font-bold text-white mt-8">Wijzigingen</h2>
          <p>EG Bouw behoudt zich het recht voor om de informatie op deze website en deze disclaimer te allen tijde te wijzigen zonder voorafgaande kennisgeving.</p>
          
          <h2 className="text-2xl font-bold text-white mt-8">Contact</h2>
          <p>Heeft u vragen over deze disclaimer? Neem dan contact met ons op via info@ella-gold.com.</p>
        </div>
      </div>
      <Footer />
    </div>
  );
};
